module.exports = __webpack_public_path__ + "img/rho-17-3d-konfigurator.6f73fbad.jpeg";